import { Box, IconButton } from '@mui/material'
import { Copy20Regular, Checkmark20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { copyIcon14Sx } from '../shared/copyIconSx.js'

export default function TableCopyButton({ copied, onCopy }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', top: '6px', right: '6px', zIndex: 1 }}>
      <Tooltip text={copied ? 'Copied!' : 'Copy table'} placement="top">
        <IconButton
          className="copy-btn"
          onClick={onCopy}
          size="small"
          sx={{
            opacity: 0,
            transition: 'opacity 0.2s',
            backgroundColor: 'var(--app-bg-panel, #ffffff)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            width: '24px',
            height: '24px',
            '&:hover': { backgroundColor: 'var(--app-bg-hover, #f5f5f5)' },
          }}
        >
          {copied ? (
            <Box component="span" sx={copyIcon14Sx} aria-hidden>
              <Checkmark20Regular />
            </Box>
          ) : (
            <Box component="span" sx={copyIcon14Sx} aria-hidden>
              <Copy20Regular />
            </Box>
          )}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
